import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'

import styles from './Footer.module.scss'

export const Footer = () => (
  <footer className={styles.Wrapper}>
    <div className={styles.Container}>
      <span className={styles.Text}>
        <FormattedMessage id={'Footer.text'}/>
      </span>
      <a href="https://www.abcgruppen.se/kundservice/" target="_blank" rel="noreferrer" className={styles.Link}>
        <FormattedMessage id={'Footer.link'}/>
      </a>
    </div>
  </footer>
)
